import { and, isOneOfEnumControl, JsonFormsRendererRegistryEntry, rankWith, optionIs } from '@jsonforms/core';
import controlRenderer from './OneOfEnumControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(50, and(isOneOfEnumControl, optionIs('version', 'v2'))),
};
